import enumeration from "./enumeration";

const TimeUnit = {
  Second: "SECOND",
  Minute: "MINUTE",
  Hour: "HOUR",
  Day: "DAY",
  Month: "MONTH",
  Year: "YEAR",
};

export default enumeration(TimeUnit);
